module.exports = __webpack_public_path__ + "static/media/006-cogwheel.7feccd3d.svg";